export default function barWidgetTooltip (dataFormatter) {
  function tooltip ({series, w, seriesIndex, dataPointIndex}) {
    const targetColor = w.config.colors[dataPointIndex];
    const value = series[seriesIndex][dataPointIndex];
    const formatterValue = dataFormatter(value);
    const categoryName = w.config.xaxis.categories[dataPointIndex];

    const total = series[seriesIndex].reduce((acc, item) => acc + item, 0);
    const percent = (value / total * 100).toFixed(0);

    // eslint-disable-next-line prefer-template
    return '<div class="apexcharts-tooltip-series-group active" style="display: flex;">' +
            '<span class="apexcharts-tooltip-marker"' +
            'style="background-color: ' + targetColor + ';"></span>' +
            '<div class="apexcharts-tooltip-text"' +
            'style="font-family: Roboto, sans-serif; font-size: 12px;">' +
            '<div class="apexcharts-tooltip-y-group">' +
            `<span class="apexcharts-tooltip-text-label">${categoryName}: </span>` +
            `<span class="apexcharts-tooltip-text-value">${formatterValue} (${percent}%)</span>` +
            '</div>' +
            '<div class="apexcharts-tooltip-z-group">' +
            '<span class="apexcharts-tooltip-text-z-label"></span>' +
            '<span class="apexcharts-tooltip-text-z-value"></span>' +
            '</div></div></div>';
  }
  return tooltip;
}
